import { Button, Tooltip } from '@chakra-ui/react'
import { Link } from 'react-router-dom'

const OfferTaskButton = ({ buttonText, label = buttonText, count, color = 'teal', link }) => {
  return (
    <Link to={link}>
      <Tooltip label={label}>
        <Button
          colorScheme={color}
          fontSize={['sm', 'md', 'lg']}
          size={['md', 'md', 'lg']}
          w={['100%', '100%', 'auto']}
          h="auto"
          py={[2, 3]}
          px={[3, 4]}
          whiteSpace="normal"
          lineHeight="short"
          textAlign="center"
        >
          {buttonText} ({count})
        </Button>
      </Tooltip>
    </Link>
  )
}

export default OfferTaskButton
